import React from 'react'
import { Column, Box, Circle, Line } from './ExpStyled'
import { ReactComponent as ProvArrowSVG } from '../../../assets/svg/provArrow.svg'
import { ReactComponent as ProvEqSVG } from '../../../assets/svg/provEq.svg'
import { ReactComponent as ProvPlusSVG } from '../../../assets/svg/provPlus.svg'
import { DIAGRAM_PROPS } from './interface'


export default function ExplanationDiagram({
  explanation_column,
  explanation_border,
  colors
}: DIAGRAM_PROPS) {

  return (
    <Column className={explanation_border} colors={colors}>
      {explanation_column.map((item: any, id: any) => (
        <div key={id}>
          <Box className={item.Round && 'round'} colors={colors}>
            {item.Content}
            {item.FirstCircle && (
              <Circle colors={colors} className={item.FirstCircle} />
            )}
            {item.SecondCircle && (
              <Circle colors={colors} className={item.SecondCircle} />
            )}
            {item.Line && <Line colors={colors} className={item.Line} />}
            {item.ArrowSVG && <ProvArrowSVG />}
          </Box>
          {item.PlusSVG && <ProvPlusSVG />}
          {item.ProvEqSVG && <ProvEqSVG />}
        </div>
      ))}
    </Column>
  )
}
